import { render, staticRenderFns } from "./waitLawyer.vue?vue&type=template&id=49e0564b&scoped=true&"
import script from "./waitLawyer.vue?vue&type=script&lang=js&"
export * from "./waitLawyer.vue?vue&type=script&lang=js&"
import style0 from "./waitLawyer.vue?vue&type=style&index=0&id=49e0564b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e0564b",
  null
  
)

export default component.exports